import React, {memo, Fragment} from 'react';
import styled from 'styled-components';
import {Element} from 'react-scroll';
import {Title2, Subhead, Title1} from '../../../../../components/Typography';
import ProductPreview from './ProductPreview';
import OrderHistoryContainer from '../../../../OrderHistory/OrderHistoryContainer';
import FavouritesListContainer from '../../../../Favourites/FavouritesList/FavouritesListContainer';
import appConfig from '../../../../../../app-config';
import ComboList from '../../../../Combo/ComboList/ComboList';

const Wrapper = styled(Element)`
  display: grid;
  grid-gap: 40px;
  padding-bottom: ${props => (props.categoryId == 999 ? '0' : '64px')};
  margin-top: ${!appConfig.isLoyaltyEnabled && !appConfig.isOffersEnabled
    ? '30px'
    : '0'};

  @media (max-width: 786px) {
    padding-bottom: ${props => (props.categoryId == 999 ? '0' : '28px')};
  }
`;

const CategoryName = styled(Title1)`
  margin-top: ${props => (props.isOffersEnabled ? '0' : '20px')};
  width: fit-content;
  font-weight: 600;

  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);
    padding-top: 2px;
    border-bottom: ${props => props.categoriesBarSelectedBorderColorWidth} solid
      ${props => props.theme.categoriesBarSelectedBorderColor};
  }
`;

const SubCategoriesWrapper = styled.div`
  display: grid;
  grid-gap: 40px;
`;

const ProductsWrapper = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    `repeat(${props.theme.productPreviewsPerRow}, 1fr)`};
  grid-gap: 24px 48px;
  @media (max-width: 786px) {
    grid-template-columns: 1fr;
  }
`;

const Category = ({
  category,
  products,
  combos,
  handleProductPreviewClick,
  handleComboPreviewClick,
}) => {
  const selectProduct = productId =>
    products.find(product => product.product_id === productId);

  return (
    <Fragment>
      {((category.products.length == 1 &&
        selectProduct(category.products[0].product_id)) ||
        category.products.length > 1 ||
        category.sub_categories ||
        category.category_id === 998 ||
        category.name === 'My Orders') && (
        <Wrapper
          name={`${category.name.toLowerCase()}_${category.category_id}`}
          className="element"
          key={category.category_id}
          categoryId={category.category_id}
        >
          {category.name === 'Combos' && category.category_id === 998 ? (
            <ComboList
              combos={combos}
              handleComboPreviewClick={handleComboPreviewClick}
            />
          ) : (
            <Fragment>
              <CategoryName id="MenuB-CategoryName">
                {category.name}
              </CategoryName>
              {category.sub_categories.length > 0 && (
                <SubCategoriesWrapper>
                  {category.sub_categories.length > 0 &&
                    category.sub_categories.map(subCategory => {
                      return subCategory.name === 'My Favourites' ? (
                        <FavouritesListContainer
                          id="MenuB-FavouritesList"
                          key={subCategory.name}
                        />
                      ) : subCategory.name === 'My Orders' ? (
                        <OrderHistoryContainer
                          id="MenuB-OrderHistory"
                          isCategory
                          key={subCategory.name}
                        />
                      ) : (
                        <ProductsWrapper key={subCategory.category_id}>
                          <Subhead
                            id="MenuB-ProductsSubhead"
                            style={{gridColumn: '1 / -1'}}
                          >
                            {subCategory.name}
                          </Subhead>
                          {subCategory.products.map(product => {
                            if (selectProduct(product.product_id)) {
                              return (
                                <ProductPreview
                                  id="MenuB-ProductPreview"
                                  key={product.product_id}
                                  product={selectProduct(product.product_id)}
                                  handleProductPreviewClick={
                                    handleProductPreviewClick
                                  }
                                />
                              );
                            }
                          })}
                        </ProductsWrapper>
                      );
                    })}
                </SubCategoriesWrapper>
              )}
            </Fragment>
          )}
          <ProductsWrapper>
            {category.products.length > 0 &&
              category.products.map(product => {
                if (selectProduct(product.product_id)) {
                  return (
                    <ProductPreview
                      id="MenuB-ProductPreview"
                      key={product.product_id}
                      product={selectProduct(product.product_id)}
                      handleProductPreviewClick={handleProductPreviewClick}
                    />
                  );
                }
              })}
          </ProductsWrapper>
        </Wrapper>
      )}
    </Fragment>
  );
};

export default memo(Category);
